import * as React from 'react'
import type { SvgIconProps } from '@mui/material'
import { BaseIcon } from '../BaseIcon'
export const CheckboxSolidIcon = (props: SvgIconProps) => (
  <BaseIcon fill="none" {...props}>
    <path
      fill="currentColor"
      d="M19.333 1A3.667 3.667 0 0 1 23 4.667v14.666A3.667 3.667 0 0 1 19.333 23H4.667l-.19-.005A3.667 3.667 0 0 1 1 19.333V4.667A3.667 3.667 0 0 1 4.667 1z"
    />
  </BaseIcon>
)
